module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.period))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.current_datetime) + "h")])]), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.pot_contracted) + " kW")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.pot_contracted))])]), _vm._v(" "), _vm._m(1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.pot_contracted * 1.05) + " kW")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.pot_penalty))])]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div')])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card",
    class: _vm.class_card_color
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.api) + " kW")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.api))])]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div')])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.current_tension))])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v("F1-F2")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.v12) + " V")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v("F2-F3")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.v23) + " V")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v("F3-F1")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.v31) + " V")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.api_now))])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.api_now))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.api) + " kW")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.active_reactive))])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.ae))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.ae) + " kW")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.ie))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.ie) + " kW")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.cosi) + " φ")])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.cosi))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.cosi) + " φ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 col-xl-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.historical_active_power))])]), _vm._v(" "), _vm._m(8)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 col-xl-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.historical_active_reactive_energy))])]), _vm._v(" "), _vm._m(9)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-xs-down col-md-2",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o fa-4x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-xs-down col-md-2",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-flash fa-4x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 hidden-xs-down",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-warning fa-4x card-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 hidden-xs-down",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-plug fa-4x card-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "width": "100%"
    },
    attrs: {
      "id": "tension-cvc10"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "295px",
      "width": "100%"
    },
    attrs: {
      "id": "active-power-cvc10"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "295px",
      "width": "100%"
    },
    attrs: {
      "id": "active-reactive-energy-cvc10"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "295px",
      "width": "100%"
    },
    attrs: {
      "id": "cosi-cvc10"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "width": "100%"
    },
    attrs: {
      "id": "pot-act-cvc10"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "width": "100%"
    },
    attrs: {
      "id": "energy-cvc10-act-react"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0734e18d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/partials/device_partials/CvmAnalyzer.vue
// module id = 529
// module chunks = 1